import type {TemplateSearchGalleryItem} from '@Components/template-search-content/components/template-search-gallery-content/template-search-gallery-content.types';
import type {SearchPillTypes} from '@Components/template-search-content/template-search-content.types';
import type {SocialPost} from '@Components/social-media/post.vo';
import type {EventVO} from '@Components/events/events.types';
import type {EmailCampaign} from '@Components/email-marketing-campaigns/email-marketing-campaigns.types';
import type {UserMailingList} from '@Components/email-marketing-campaign-performance/email-marketing-campaign-performance.types';
import type {SignupForm} from '@FormMakerReact/email-signup-form.types';

export const NAV_SEARCH_MOBILE_OPEN_EVENT = 'pmw-open-nav-search-mobile';
export const NAV_SEARCH_MOBILE_ACTIVE_BODY_CLASS = '-_mobile-search-active';
export const NAV_SEARCH_CLOSE_MOBILE_NAV_EVENT = 'pmw-close-mobile-nav';
export const NAV_SEARCH_SECTION_ITEMS_LIMIT = 3;
export const NAV_SEARCH_NAVIGATION_TIMEOUT_MS = 10000;

/** Setting `window.location.href` does not navigate synchronously, so the overlay stays mounted until the new document arrives. */
export enum NavSearchEnterOutcome {
  NAVIGATING = 'NAVIGATING',
  FILTERED_IN_PLACE = 'FILTERED_IN_PLACE',
  NOOP = 'NOOP',
}

export interface NavSearchSectionData {
  posts: SocialPost[];
  events: EventVO[];
  campaigns: EmailCampaign[];
  mailingLists: UserMailingList[];
  signupForms: SignupForm[];
}

export interface NavSearchSectionRecentsPayload {
  scope: SearchPillTypes;
  data: Partial<NavSearchSectionData>;
}

export interface NavSearchReduxState {
  isInitialContentLoading: boolean;
  isMyDesignContentLoading: boolean;
  isSectionContentLoading: boolean;
  searchTerm: string;
  selectedContentType: SearchPillTypes;
  gallerySearchItems: TemplateSearchGalleryItem[];
  trendingItems: TemplateSearchGalleryItem[];
  userCreatedPosters: NavPosterMeta[];
  userCreatedFolders: NavFolderMeta[];
  userSearchPosters: NavPosterMeta[];
  /** Search owns its own section data so it renders on a cold gallery page too. */
  sectionRecents: NavSearchSectionData;
  sectionResults: NavSearchSectionData;
  loadedRecentScopes: SearchPillTypes[];
}

export interface NavSearchContentAjaxResponse {
  gallerySearchItems: TemplateSearchGalleryItem[];
  trendingItems: TemplateSearchGalleryItem[];
  posters: NavPosterMeta[];
  folders: NavFolderMeta[];
}

export interface NavPosterMeta {
  hid: string;
  name: string;
  previewURL: string;
}

export interface NavFolderMeta {
  id: string;
  name: string;
  createdOn: number;
}

export interface NavSearchScreenSizeTypes {
  isMobile: boolean;
  isSmallTablet: boolean;
  isCompactTablet: boolean;
  isNarrowTablet: boolean;
  isTablet: boolean;
  isSmallDesktop: boolean;
  isDesktop: boolean;
}

export const getEmptyNavSearchSectionData = (): NavSearchSectionData => {
  return {
    posts: [],
    events: [],
    campaigns: [],
    mailingLists: [],
    signupForms: [],
  };
};
